export const actionTypes = {
  REQUEST_START: 'AUTHORIZATION.CHECK_TOKEN.REQUEST_START',
  SUCCESS: 'AUTHORIZATION.CHECK_TOKEN.SUCCESS',
  FAILURE: 'AUTHORIZATION.CHECK_TOKEN.FAILURE',
};

export function startRequest(token, redirectUrl) {
  return {
    type: actionTypes.REQUEST_START,
    payload: {
      token,
      redirectUrl,
    },
  };
}

export function requestSuccess() {
  return {
    type: actionTypes.SUCCESS,
    payload: null,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.FAILURE,
    payload: error,
  };
}
